import { defineStore, acceptHMRUpdate } from 'pinia'
import { getgroupSendTaskListApi } from "@/api/qwSendMessage.js";
import { ElNotification } from 'element-plus';
export const useTaskListStore = defineStore({
  id: 'taskList',
  state: () => ({
    taskList:[],
    currentTaskTabId:'',
    taskListLoadError: false,
    taskListLoading:false,
  }),
  actions: {
    updateTaskList() {
        this.taskListLoading = true;
        return getgroupSendTaskListApi().then(res=>{
            this.taskListLoading = false;
            this.taskList = res || [];
            if(!this.currentTaskTabId){
              this.currentTaskTabId = res[0]?.taskId;
            }
        }).catch((error)=>{
            this.taskListLoading = false;
            this.taskListLoadError = true;
        })
    },
    setCurrentTaskTabId(taskId){
      this.currentTaskTabId = taskId;
    }
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTaskListStore, import.meta.hot))
}
